export default __webpack_public_path__ + "static/media/notfound1.694b4357.png";